module.exports = __webpack_public_path__ + "static/media/icon_new.436c3461.svg";